import { EmployeeOffboardingFailureReason } from './EmployeeOffboardingFailureReason';

export interface IEmployeeOffboardingFailureData {
  employeeId: number;
  employeeName: string;
  reason: EmployeeOffboardingFailureReason;
}

export function isEmployeeOffboardingFailureData(data: unknown): data is IEmployeeOffboardingFailureData {
  if (typeof data !== 'object' || data === null) {
    return false;
  }

  const candidate = data as Partial<IEmployeeOffboardingFailureData>;
  return (
    typeof candidate.employeeId === 'number' &&
    typeof candidate.employeeName === 'string' &&
    typeof candidate.reason === 'string' &&
    Object.values(EmployeeOffboardingFailureReason).includes(candidate.reason)
  );
}
